import { ReactComponent as IconEye } from "@/assets/svgs/Union-eye.svg";
import { Box, Grid } from "@dextech-ai/dex-design-system";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { TableBody } from "./blockchain-table/table-body";

export const ConfigureIssuanceSection = ({
	setEtrIssuanceEnabled,
	status,
	noEtrPersonaSelected,
	etrIssuanceEnabled,
	toggleEtrIssuance,
	blockchainNetworks,
	loading,
	error,
	toggleBlockchainNetwork,
	toggleAllBlockchainNetworks,
}) => {
	useEffect(() => {
		if (!etrIssuanceEnabled || noEtrPersonaSelected) {
			toggleAllBlockchainNetworks(false);
		}
	}, [etrIssuanceEnabled, noEtrPersonaSelected]);


	useEffect(() => {
		//first time enrollment && when there are etrPersonas being selected.
		if (status === "not-enrolled" && !noEtrPersonaSelected) {
			setEtrIssuanceEnabled(true)
			toggleAllBlockchainNetworks(true)
		}
	}, [])
	return (
		<>
			<div
				data-testid="participant-enroll-layout-3"
				className="layout-enroll"
			>
				<Grid className="layout-enroll__content" columns={1} rowGap={3}>
					<div
						style={{ marginBottom: 0 }}
						className={`etr-issuance__etr-issuance-section ${!noEtrPersonaSelected || etrIssuanceEnabled
							? "etr-issuance__etr-issuance-section--enabled"
							: "etr-issuance__etr-issuance-section--disabled"
							}`}
					>
						<div className="etr-issuance__etr-issuance-header">
							<div>ETR Issuance</div>
							<Box display="flex" gap={2}>
								<label
									className="switch"
									htmlFor="etrIssuanceCheckbox"
								>
									<input
										disabled={noEtrPersonaSelected}
										data-testid="etrIssuanceCheckbox"
										type="checkbox"
										id="etrIssuanceCheckbox"
										checked={
											!noEtrPersonaSelected &&
											etrIssuanceEnabled
										}
										onChange={toggleEtrIssuance}
									/>
									<span className="slider round" data-testid="etrIssuanceCheckbox-icon"></span>
								</label>
							</Box>
						</div>
						{noEtrPersonaSelected && (
							<div>
								Issuance unavailable for the selected persona.
							</div>
						)}
					</div>
					<div
						id="blockchainSection"
						className={`etr-issuance__blockchain-section ${!noEtrPersonaSelected && etrIssuanceEnabled
							? "etr-issuance__blockchain-section--enabled"
							: "etr-issuance__blockchain-section--disabled"
							}`}
					>
						<div className="etr-issuance__blockchain-section-header">
							Blockchain
						</div>
						<div className="etr-issuance__warning-container">
							<IconEye className="etr-issuance__icon-default" />
							<p className="etr-issuance__text-subtitle">
								{etrIssuanceEnabled
									? "Indicate which blockchain to be included/excluded for ETR issuance."
									: "BlockChain requires ETR Issuance to be enabled"}
							</p>
						</div>
						<table
							className={`etr-issuance__blockchain-table ${noEtrPersonaSelected && etrIssuanceEnabled ? "etr-issuance__blockchain-table--disabled" : ""}`}
						>
							<thead className="etr-issuance__table-head">
								Network
								<div className="etr-issuance__flex-row">
									<div className="etr-issuance__text-subtitle">
										{blockchainNetworks.length > 0 &&
											blockchainNetworks.every(
												(item) => item.$selected
											)
											? "Include"
											: "Exclude"}{" "}
										All
									</div>
									<label className="switch etr-issuance__margin-default">
										<input
											data-testid="etr-issuance__blockchain-table-checkbox"
											type="checkbox"
											disabled={
												!etrIssuanceEnabled ||
												blockchainNetworks.length ===
												0 ||
												noEtrPersonaSelected
											}
											checked={
												blockchainNetworks.length > 0 &&
												blockchainNetworks.every(
													(item) => item.$selected
												)
											}
											onChange={(e) =>
												toggleAllBlockchainNetworks(
													e.target.checked
												)
											}
										/>
										<span className="slider round"></span>
									</label>
								</div>
							</thead>
							<TableBody
								etrIssuanceEnabled={etrIssuanceEnabled}
								noEtrPersonaSelected={noEtrPersonaSelected}
								error={error}
								blockchainNetworks={blockchainNetworks}
								loading={loading}
								toggleBlockchainNetwork={
									toggleBlockchainNetwork
								}
							/>
							<tfoot className="etr-issuance__table-foot">
								<tr>
									<td>
										Showing {blockchainNetworks.length}{" "}
										entries
									</td>
								</tr>
							</tfoot>
						</table>
					</div>
				</Grid>
			</div>
		</>
	);
};

ConfigureIssuanceSection.propTypes = {
	setEtrIssuanceEnabled: PropTypes.func,
	status: PropTypes.string,
	noEtrPersonaSelected: PropTypes.bool,
	etrIssuanceEnabled: PropTypes.bool,
	toggleEtrIssuance: PropTypes.func,
	blockchainNetworks: PropTypes.array,
	loading: PropTypes.bool,
	error: PropTypes.string,
	toggleBlockchainNetwork: PropTypes.func,
	toggleAllBlockchainNetworks: PropTypes.func,
};

export default ConfigureIssuanceSection;
